var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full p-20 bg-gray-10"},[_c('div',[_c('h1',{staticClass:"text-h32 mb-20"},[_vm._v(" Message 全局提示 ")]),_c('div',[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.info}},[_vm._v(" Display normal message ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }